import { Dialog, TextInputField } from "evergreen-ui";
import React, { useContext } from "react";
import Button from "src/Components/Button";
import { LanguageStore } from "src/Context/LanguageStore";
import { InputHooksType } from "src/Types/data-types";
import styled from "styled-components";

const Container = styled.form`
  ${(props) => props.theme.whiteBox};
  padding: 0px;
`;
const Title = styled.h1`
  ${(props) => props.theme.title};
  margin-bottom: 0.5rem;
`;

const Body = styled.div`
  padding: 1.5rem;
  width: 100%;
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 1rem;
`;

const Footer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 1rem;
  background-color: ${(props) => props.theme.extraLightGreyColor};
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 100%;
`;

const ButtonHolder = styled.div``;

const Bold = styled.span`
  font-weight: 700;
`;
const SmallDarkText = styled.p`
  font-size: 0.8rem;
  line-height: 1.5;
  margin-bottom: 1rem;
`;
interface IProps {
  uplineUsername: InputHooksType;
  onChange: any;
  submitSearch: any;
  showBox: boolean;
  upline: any;
  closeSearch: any;
  loading: boolean;
  onSubmit: any;
  country: any;
}
const SetupUplinePresenter: React.SFC<IProps> = ({
  uplineUsername,
  onChange,
  submitSearch,
  showBox,
  upline,
  loading,
  onSubmit,
  country,
  closeSearch,
}) => {
  const { dictionary } = useContext(LanguageStore);
  return (
    <Container>
      <Body>
        <Header>
          {dictionary.step} 1/{country.length > 1 ? 3 : 2}
        </Header>
        <Title>{dictionary.whoIntroducedYou}</Title>
        <TextInputField
          value={uplineUsername.value}
          onChange={onChange}
          label=""
        />
      </Body>
      <Footer>
        <SmallDarkText>{dictionary.referralDescription}</SmallDarkText>
        <ButtonWrapper>
          <ButtonHolder>
            <Button
              label="Check"
              onClick={submitSearch}
              disabled={uplineUsername.value === "" || loading}
            />
          </ButtonHolder>
        </ButtonWrapper>
      </Footer>
      {showBox && (
        <Dialog
          onCancel={closeSearch}
          onConfirm={onSubmit}
          isConfirmLoading={loading}
          onCloseComplete={closeSearch}
          title={dictionary.confirmUpline}
          isShown={showBox}
        >
          {dictionary.isYourUpline}
          <Bold>{upline.name}</Bold>?
          <br />
          <br />
          <Bold>{dictionary.cannotChangeUpline}</Bold>
        </Dialog>
      )}
    </Container>
  );
};

export default SetupUplinePresenter;
